<template>
  <div class="login">
    <br />
    <br />
    <br />

    <login-form />

    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'login'
}
</script>